import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tooltip',
  props: {
    // 内容
    content: {
        type: String,
        required: true
    },
    // 出现位置
    placement: {
        type: String,
        default: 'bottom'
    },
},
  setup(__props) {

const props = __props;



let isDisabled = ref(false)

const isShowTooltip = (e: any) => {

    let clientWidth = e.target.clientWidth,
        scrollWidth = e.target.scrollWidth,
        arrList = Array.from(e.target.classList)
    // console.log('clientWidth', clientWidth, scrollWidth, scrollWidth > clientWidth);
    // 当文字显示不全时，才需要hover显示tootip文字
    if (scrollWidth > clientWidth) {
        isDisabled.value = false
        if (!arrList.includes('hover-blue')) {
            e.target.classList.add('hover-blue')
        }
    } else {
        isDisabled.value = true
        e.target.classList.remove('hover-blue')
    }
}
const linkTo = () => {

}
onMounted(() => {
    console.log("进来了");

})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    content: __props.content,
    placement: __props.placement,
    disabled: _unref(isDisabled),
    "show-after": 200,
    "popper-class": "myTooltip"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["contentnowrap", { isLink: 'link-text' }]),
        onMouseenter: isShowTooltip,
        onClick: linkTo
      }, _toDisplayString(__props.content), 33)
    ]),
    _: 1
  }, 8, ["content", "placement", "disabled"]))
}
}

})